import cx from 'classnames';
import type { VoidFunctionComponent } from 'react';

import { Icon } from '../../../generic';
import type { IconClassName } from '../../../generic';

import styles from './Filters.module.less';

type Props = {
  icon: IconClassName;
  label: string;
  className?: string;
};

const LabelWrapper: VoidFunctionComponent<Props> = ({ icon, label, className }) => (
  <div className={cx(styles.LabelWrapper, className)}>
    <Icon icon={icon} />
    {label}
  </div>
);

export default LabelWrapper;
